import pick from 'lodash/pick';
import { createSelector } from 'reselect';

export const getQueryParams = state => state.queryParams;

export const pickQueryParams = (params = []) =>
  createSelector(getQueryParams, query => pick(query, params));
